export const DEFAULT_LANG = 'en';
export const AVAILABLE_LANGS = ['de', 'en', 'es', 'fr', 'it', 'pt', 'ru', 'zh'];

export const WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export const DEFAULT_CAMPAIGN_START_TIME = '00:00';
export const DEFAULT_CAMPAIGN_END_TIME = '23:59';